import styled from 'styled-components';
import { breakpoint } from '../../theme/breakpoint';
import { Container } from '../../styled/containers';
import CTA from '../../cta';

export const Wrapper = styled.div`
  overflow: hidden;
  background: ${({ theme }) => theme.palette.darkBackground};
  padding: ${({ theme }) => `${theme.spacing.medium} 0`};
  margin-bottom: ${({ theme }) => theme.spacing.large};
`;

export const StyledContainer = styled(Container)`
  padding: 0;
  display: flex;
  flex-direction: column;

  ${breakpoint.desktop`
    padding: ${({ theme }) => `0 ${theme.spacing.standard}`};
    flex-direction: row;
    
    > * {
      flex: 1 1 0;
    }
  `};
`;

export const BannerContent = styled.div`
  position: relative;
  color: ${({ theme }) => theme.palette.white};
  width: 100%;
  padding: ${({ theme }) => `0 ${theme.spacing.tiny}`};

  ${breakpoint.desktop`
    padding: 0;
  `};
`;

export const MediaContainer = styled.div`
  margin: ${({ theme }) => `${theme.spacing.medium} ${theme.spacing.tiny}`};
  color: ${({ theme }) => theme.palette.white};

  ${breakpoint.desktop`
    flex: 2 1 0;
    margin: 0 0 0 ${({ theme }) => `${theme.spacing.standard}`};
  `};

  picture {
    display: block;

    img {
      max-width: 100%;
      height: auto;
    }
  }
`;

export const Title = styled.h1`
  font-family: ${({ theme }) => theme.fonts.condensed};
  margin-top: 0;
  margin-bottom: 0;
  text-transform: uppercase;
`;

export const StyledCTA = styled(CTA)`
  ${({ $addLeftMargin, theme }) =>
    $addLeftMargin ? `margin-left: ${theme.spacing.standard}` : ''};
`;

export const MobileContent = styled.div`
  ${breakpoint.desktop`
    display: none;
  `};
`;

export const DesktopContent = styled.div`
  display: none;

  ${breakpoint.desktop`
    display: block;
  `};
`;
